import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../authentication/authentication.service';
import { Token } from 'app/shared/models/token';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshDone$ = new BehaviorSubject<string | null>(null);

  constructor(private auth: AuthService, private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !request.url.includes('auth/refresh') && !request.url.includes('auth/login')) {
          return this.handle401(request, next);
        }

        if (error.error instanceof ErrorEvent) {
          return throwError(`Error: ${error.error.message}`);
        }
        return throwError(`Error Code: ${error.status}\nMessage: ${error.message}`);
      })
    );
  }

  private handle401(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshDone$.next(null);

      return this.auth.refreshAccessToken().pipe(
        switchMap((token: Token) => {
          this.isRefreshing = false;
          localStorage.setItem('jwt', token.token);
          if (token.refreshToken) {
            localStorage.setItem('refreshToken', token.refreshToken);
          }
          this.auth.onDecodedToken(token.token);
          this.refreshDone$.next(token.token);
          return next.handle(this.addToken(request, token.token));
        }),
        catchError(() => {
          this.isRefreshing = false;
          this.auth.logout();
          return throwError('Session expired. Please log in again.');
        })
      );
    }

    // Another request is already refreshing — wait for the new token then retry
    return this.refreshDone$.pipe(
      filter(token => token !== null),
      take(1),
      switchMap(token => next.handle(this.addToken(request, token!)))
    );
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }
}
